// extracted by mini-css-extract-plugin
module.exports = {"DateRangeSelect":"DateRangeSelect_DateRangeSelect__2C4P-"};